import { RSAA } from 'redux-api-middleware';
import reduxStore from '../store/store';
import { logIntegration } from '../store/actions/log-actions';
import {
  SUBMIT_LEAD_COMPLEMENT_SUCCESS,
  SUBMIT_NEW_LEAD_SUCCESS,
  SUBMIT_BANK_STATEMENT_SUCCESS,
} from '../store/actions/application-actions';
import {
  AUTH_LOGIN_SUCCESS,
  REQUEST_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  logged,
  logout,
} from '../store/actions/auth-actions';

import { setEventOnDataLayer } from '../utils/helper/datalayer-events-helper';
import { resetUtilState } from '../store/actions/util-actions';
import browserHistory from '../navigation/history';
import Routes from '../../../resources/routes.json';

export default function () {
  return function (next) {
    return async function (action) {
      const callApi = action[RSAA];
      // Pass the FSA to the next action.
      const response = await next(action);

      asyncLogError(response, callApi);
      addDataLayerEventTrigger(response);

      if (response.payload?.status == 401) {
        await reduxStore.dispatch(resetUtilState());
        await reduxStore.dispatch(logout());
        browserHistory.replace(Routes.CUSTOMER_LOGIN.DEFAULT);
      }

      return response;
    };
  };
}

/**
 * Logging API integration errors
 * @param {*} response
 * @param {*} callApi
 */
const asyncLogError = async (response, callApi) => {
  const LOGGED_STATUS = [405, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511];

  if (response && response.error && LOGGED_STATUS.includes(response.payload?.status)) {
    const { payload, type } = response;
    const errorToLog = `${payload.message} - action: ${type} - endpoint: ${callApi?.endpoint} - method: ${callApi?.method}`;
    const device = reduxStore?.getState()?.customer?.device;
    const input = [];

    reduxStore.dispatch(
      logIntegration('application-customer-portal-web-integration-error', null, input, null, errorToLog, device, null),
    );
  }
};

/**
 * Adding datalayer events triggers into sessionStorage for api calls
 * @param {*} response
 */
const addDataLayerEventTrigger = (response) => {
  if (response && response.type) {
    if (response.type == REQUEST_PASSWORD_SUCCESS) {
      sessionStorage.setItem('dataLayerApplicationEvent', 'requestResetPasswordEvent');
    } else if (response.type == CHANGE_PASSWORD_SUCCESS) {
      sessionStorage.setItem('dataLayerApplicationEvent', 'changePasswordEvent');
    } else if (response.type == SUBMIT_BANK_STATEMENT_SUCCESS) {
      sessionStorage.setItem('dataLayerApplicationEvent', 'manualIncomeProofEvent');
    }

    window.dispatchEvent(new Event('dataLayerApplicationEvent'));
  }
};
